import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

import EditorialButton from '../editorial/EditorialButton';

const cardSx = {
  p: { xs: 3, md: 4 },
  mb: 3,
  border: '1px solid rgba(36,34,88,0.15)',
  background: 'var(--paper)',
};

export const membershipBillingLabel = (membership) => {
  if (!membership) return null;
  if (membership.isFree) return 'Complimentary';
  if (membership.billingCycle === 'monthly') return 'Monthly';
  if (membership.billingCycle === 'annual') return 'Annual';
  return null;
};

export const purchasedSeatCount = (purchasedSeats) =>
  (purchasedSeats?.menSeatNames?.length || 0) + (purchasedSeats?.womenSeatNames?.length || 0);

// Membership 5787 (and Give Butter Partner) details on My Account.
// The seats panel owns the actual guest-seat list and the buy-more form;
// this card is the household-side summary so a member who enrolled on
// /membership2026 can see the tier they paid for without digging.
export default function AccountMembershipSummary({
  membership,
  guestSeatCount = 0,
  onManageSeats,
}) {
  if (!membership || membership.status !== 'active') return null;

  const billing = membershipBillingLabel(membership);
  const details = ['Active', billing].filter(Boolean).join(' · ');

  return (
    <Box sx={cardSx}>
      <Stack spacing={1.5}>
        <Typography variant="overline" color="text.secondary" sx={{ display: 'block' }}>
          Membership 5787
        </Typography>
        <Typography
          sx={{
            fontFamily: 'var(--font-display)',
            fontWeight: 700,
            fontSize: { xs: 22, md: 26 },
            lineHeight: 1.2,
            color: 'var(--navy-500)',
          }}
        >
          {membership.tierName || 'Member'}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {details}
          {guestSeatCount > 0
            ? ` · ${guestSeatCount} guest seat${guestSeatCount === 1 ? '' : 's'} reserved`
            : ''}
        </Typography>
        {onManageSeats && (
          <EditorialButton variant="ghost" onClick={onManageSeats} sx={{ alignSelf: 'flex-start', mt: 0.5 }}>
            {guestSeatCount > 0 ? 'View seats & add guests' : 'High Holiday seats'}
          </EditorialButton>
        )}
      </Stack>
    </Box>
  );
}
